var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "create-third-form" },
    [
      _c("h2", { staticClass: "mt-0 mr-4 flex-row mb-4" }, [
        _vm._v(_vm._s(_vm.settings.title))
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: _vm.popupStore,
          staticClass:
            "flex-column form-fields-company form-fields-shorten mb-0 flex-row jc-space",
          attrs: {
            "label-position": "top",
            model: _vm.model,
            rules: _vm.createThirdRules
          },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submitForm(_vm.popupStore)
            }
          }
        },
        [
          _c("form-fields-" + _vm.options.types.type + "-shorten", {
            tag: "component",
            attrs: {
              "data-bots-context": _vm.current,
              "current-store": _vm.popupStore
            },
            on: { "change-type": _vm.changeType }
          }),
          _vm._v(" "),
          _c("form-fields-custom-fields", {
            attrs: {
              "type-label": _vm.settings.label,
              "current-store": _vm.popupStore,
              "allow-add": false,
              "current-customfields": _vm.customfields
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pt-3 pl-5 flex-level flex-end span_12 zi-2" },
            [
              _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__("common.actions.cancel"),
                  type: "secondary",
                  "data-bot": _vm.getDatabot(
                    "btn-cancel",
                    _vm.current,
                    null,
                    _vm.options.types.type + "-popup"
                  )
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              }),
              _vm._v(" "),
              _c("CompassButton", {
                staticClass: "ml-3",
                attrs: {
                  label: _vm.$t.__("common.actions.save"),
                  type: "primary",
                  submit: "",
                  "data-bot": _vm.getDatabot(
                    "btn-save",
                    _vm.current,
                    null,
                    _vm.options.types.type + "-popup"
                  )
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }